export default __webpack_public_path__ + "static/media/teachers.c35ec24e.svg";